/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationRoleModelSearchResultModel } from '../../models/organization-role-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface OrganizationRoleSearchOrganizationRolePost$Params {
      body?: SearchRequestModel
}

export function organizationRoleSearchOrganizationRolePost(http: HttpClient, rootUrl: string, params?: OrganizationRoleSearchOrganizationRolePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<OrganizationRoleModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, organizationRoleSearchOrganizationRolePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<OrganizationRoleModelSearchResultModel>;
    })
  );
}

organizationRoleSearchOrganizationRolePost.PATH = '/OrganizationRole/SearchOrganizationRole';
